import { WordPressPost } from './wordpress';
import { contentLinker } from './contentLinker';

interface RelatedPostsOptions {
  currentPost: WordPressPost;
  allPosts: WordPressPost[];
  maxResults?: number;
}

class RelatedPostsService {
  findRelatedPosts({ currentPost, allPosts, maxResults = 3 }: RelatedPostsOptions): WordPressPost[] {
    // Filter out the current post
    const otherPosts = allPosts.filter(post => post.id !== currentPost.id);
    
    // Score posts based on similarity
    const scoredPosts = otherPosts.map(post => ({
      post,
      score: this.calculateSimilarityScore(currentPost, post)
    }));

    // Sort by score and return top results
    return scoredPosts
      .sort((a, b) => b.score - a.score)
      .slice(0, maxResults)
      .map(item => item.post);
  }

  private calculateSimilarityScore(post1: WordPressPost, post2: WordPressPost): number {
    let score = 0;

    // Category similarity (highest weight)
    const sharedCategories = post1.categories.filter(cat => 
      post2.categories.includes(cat)
    ).length;
    score += sharedCategories * 3;

    // Tag similarity
    const sharedTags = post1.tags.filter(tag => 
      post2.tags.includes(tag)
    ).length;
    score += sharedTags * 2;

    // Content keyword similarity
    const post1Keywords = contentLinker.extractKeywords(
      post1.title.rendered + ' ' + post1.excerpt.rendered
    );
    const post2Keywords = contentLinker.extractKeywords(
      post2.title.rendered + ' ' + post2.excerpt.rendered
    );

    const sharedKeywords = post1Keywords.filter(keyword =>
      post2Keywords.some(k => k.toLowerCase() === keyword.toLowerCase())
    ).length;
    score += sharedKeywords * 1;

    // Recency bonus (slight preference for newer posts)
    const daysDiff = Math.abs(
      new Date(post1.date).getTime() - new Date(post2.date).getTime()
    ) / (1000 * 60 * 60 * 24);
    
    if (daysDiff < 30) {
      score += 0.5;
    }

    return score;
  }
}

export const relatedPostsService = new RelatedPostsService();